import { stdObject } from "../data/types/stdObject";

export const arrangeBatches = ({ data, table, batchesBox }: stdObject) => {
  const { line, item, serie2 } = data;
  console.log("vvv", table, batchesBox);
  const batchesTable = table.map((e: stdObject) => {
    if (serie2) {
      const keyIndex = batchesBox.findIndex(
        (v: stdObject) => v.IDBA0 === e.data.IDBA0,
      );
      batchesBox[keyIndex].TRABA0 = e.data.CANBA0;
      return {
        ...e,
        ARTBA0: item,
        LINBA0: line,
        TRABA0: e.data.CANBA0,
      };
    } else {
      batchesBox.push({
        IDBA0: e.data.IDBA0,
        CANBA0: e.data.CANBA0,
        EXPBAT: e.data.EXPBAT,
      });
      return {
        IDBA0: e.data.IDBA0,
        ARTBA0: item,
        LINBA0: line,
        CANBA0: e.data.CANBA0,
        EXPBAT: e.data.EXPBAT,
      };
    }
  });
  return { batchesTable, batchesBox };
};
